import { functionsService } from "services";
import { listFromApiResponse } from "utils/functionsApi";

export const getAllFunctions = (query, enabled) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try{
		const list = await functionsService.getAll(query, enabled);

		if (!list.ok) {
			const msg =
				list.errors?.[0]?.description || "Error al cargar las funciones";
			dispatch({
				type: 'ERROR',
				payload: msg
			});
			return;
		}

		dispatch({
			type: 'GET_FUNCTIONS',
			payload: listFromApiResponse(list)
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}

export const getSelectableFunctions = () => async (dispatch) => {

	try{
		const list = await functionsService.getSelectable();

		if (!list.ok) {
			console.warn("getSelectableFunctions: respuesta no ok", list);
			dispatch({
				type: 'GET_SELECT_FUNCTIONS',
				payload: []
			});
			return;
		}

		dispatch({
			type: 'GET_SELECT_FUNCTIONS',
			payload: listFromApiResponse(list)
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}

export const getEnabledFunctions = () => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try{
		const list = await functionsService.getAll(undefined, true);

		if (!list.ok) {
			const msg =
				list.errors?.[0]?.description || "Error al cargar las funciones";
			dispatch({
				type: 'ERROR',
				payload: msg
			});
			return;
		}

		dispatch({
			type: 'GET_FUNCTIONS',
			payload: listFromApiResponse(list)
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}